module.exports = (__parcel__import__("iFOKZ")).then(() => parcelRequire('8OYBW'));